import TabPage from "../../factories/tab-page";
import GenericListSearchTab from "../../factories/generic-list-search-tab";
import * as ko from "knockout";
import BaoService from "../../services/bao-service";
/**
 * Contains Frontend logic for the MandatorInlineFrameReportTab
 * The Relation between Mandator and InlineFrame Report
 */
class MandatorInlineFrameReportTab extends GenericListSearchTab
{
    constructor(public TabPage: TabPage, public Parent: any) {
        super(TabPage, Parent);
        this.Bao = BaoService;
        this.DirtyFlag = Parent.TabPage.DirtyFlag;
        this.DialogWidth = 600;
    }

    public DirtyFlag: any;
    public Bao = null;

    public CustomFilter() {
        var customFilterHashObject = [];

        return customFilterHashObject;
    }

    public ItemCompleteCheck(item: any) {
        let def = $.Deferred<any>();
        def.resolve(true);
        return def.promise();
    }

    SearchType(): string {
        return "Mandator";
    }
}
export default MandatorInlineFrameReportTab;